/**
 * Haley Purify PDP
 * Gallery switching and Shopify variant state sync.
 */
(function () {
  'use strict';

  const container = document.querySelector('[data-hp-product]');
  if (!container) return;

  const productJson = document.getElementById('hp-product-json');
  if (!productJson) return;

  let variants = [];
  try {
    variants = JSON.parse(productJson.textContent);
  } catch (error) {
    console.error('Haley Purify: unable to parse variants', error);
    return;
  }

  const mainImage = container.querySelector('[data-hp-main-image]');
  const galleryMain = container.querySelector('[data-hp-gallery-main]');
  const galleryThumbs = container.querySelectorAll('[data-hp-gallery-thumb]');
  const variantIdInputs = container.querySelectorAll('input[name="id"]');
  const priceEls = container.querySelectorAll('[data-hp-price]');
  const compareEls = container.querySelectorAll('[data-hp-compare]');
  const discountEls = container.querySelectorAll('[data-hp-discount]');
  const ctaPriceEls = container.querySelectorAll('[data-hp-cta-price]');
  const addTextEls = container.querySelectorAll('[data-hp-add-text]');
  const addButtons = container.querySelectorAll('button[name="add"]');
  const optionInputs = container.querySelectorAll('input[data-option-index]');
  const sizeCards = container.querySelectorAll('[data-hp-size-card]');
  const sizeSelects = container.querySelectorAll('[data-hp-size-select]');
  const exclusiveAccordionGroups = container.querySelectorAll('[data-hp-exclusive-accordions]');
  let gallerySwapTimer = null;
  let gallerySwapId = 0;

  function formatMoney(cents, withCents) {
    const value = Number(cents || 0) / 100;
    return 'HK$' + value.toLocaleString('en-HK', {
      minimumFractionDigits: withCents ? 2 : 0,
      maximumFractionDigits: withCents ? 2 : 0
    });
  }

  function selectedOptions() {
    const options = {};
    optionInputs.forEach((input) => {
      if (input.checked) {
        options[input.dataset.optionIndex] = input.value;
      }
    });
    return options;
  }

  function findVariantByOptions(options) {
    return variants.find((variant) => {
      return Object.keys(options).every((index) => {
        const optionKey = 'option' + (Number(index) + 1);
        return variant[optionKey] === options[index];
      });
    });
  }

  function setUrlVariant(variant) {
    if (!window.history || !window.history.replaceState) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function updateVariant(variant) {
    if (!variant) return;

    variantIdInputs.forEach((input) => {
      input.value = variant.id;
    });

    priceEls.forEach((el) => {
      el.textContent = formatMoney(variant.price, false);
    });

    // Nightly cost line under the price (snippets/haley-per-night.liquid)
    container.querySelectorAll('[data-haley-per-night]').forEach((el) => {
      const amount = el.querySelector('[data-per-night-amount]');
      const nights = Number(el.dataset.nights) || 0;
      if (amount && nights > 0) amount.textContent = 'HK$' + (Math.floor(variant.price / nights) / 100).toFixed(2);
    });

    ctaPriceEls.forEach((el) => {
      el.textContent = variant.available ? formatMoney(variant.price, false) : '';
    });

    const hasCompare = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
    compareEls.forEach((el) => {
      if (hasCompare) {
        el.hidden = false;
        el.textContent = formatMoney(variant.compare_at_price, false);
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    });

    discountEls.forEach((el) => {
      if (hasCompare) {
        const percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        el.hidden = false;
        el.textContent = '-' + percent + '%';
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    });

    addButtons.forEach((button) => {
      button.disabled = !variant.available;
    });

    addTextEls.forEach((el) => {
      el.textContent = variant.available ? (el.dataset.textAvailable || '加入購物車') : '已售完';
    });

    sizeCards.forEach((card) => {
      const isActive = String(card.dataset.variantId) === String(variant.id);
      card.classList.toggle('is-active', isActive);
      const input = card.querySelector('input');
      if (input) input.checked = isActive;
    });

    sizeSelects.forEach((select) => {
      select.value = String(variant.id);
    });

    optionInputs.forEach((input) => {
      const optionKey = 'option' + (Number(input.dataset.optionIndex) + 1);
      const isMatch = variant[optionKey] === input.value;
      if (isMatch) {
        input.checked = true;
        const wrapper = input.closest('.hp-variant-btn');
        if (wrapper) wrapper.classList.add('is-active');
      } else if (!input.closest('[data-hp-size-card]')) {
        const wrapper = input.closest('.hp-variant-btn');
        if (wrapper) wrapper.classList.remove('is-active');
      }
    });

    setUrlVariant(variant);
    container.dispatchEvent(new CustomEvent('haley:variant-change', { bubbles: true, detail: variant }));
  }

  function setHeroFrame(thumb) {
    if (!galleryMain) return;
    const isHeroFrame = Boolean(thumb && thumb.dataset.hpHeroFrame === 'true');
    galleryMain.dataset.hpHeroActive = isHeroFrame ? 'true' : 'false';
  }

  function cueGallerySwap() {
    if (!galleryMain || !mainImage) return;
    gallerySwapId += 1;
    const activeSwapId = gallerySwapId;

    galleryMain.classList.add('is-switching');
    window.clearTimeout(gallerySwapTimer);

    const settle = () => {
      if (activeSwapId !== gallerySwapId) return;
      galleryMain.classList.remove('is-switching');
      mainImage.removeEventListener('load', settle);
    };

    mainImage.addEventListener('load', settle, { once: true });
    gallerySwapTimer = window.setTimeout(settle, 520);
  }

  galleryThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage || !thumb.dataset.src) return;
      cueGallerySwap();
      mainImage.src = thumb.dataset.src;
      mainImage.alt = thumb.dataset.alt || mainImage.alt;
      galleryThumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      setHeroFrame(thumb);
    });
  });

  setHeroFrame(container.querySelector('[data-hp-gallery-thumb].is-active') || galleryThumbs[0]);

  sizeCards.forEach((card) => {
    card.addEventListener('click', (event) => {
      if (card.dataset.available === 'false') {
        event.preventDefault();
        return;
      }

      const variant = variants.find((item) => String(item.id) === String(card.dataset.variantId));
      if (variant) updateVariant(variant);
    });
  });

  optionInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const variant = findVariantByOptions(selectedOptions());
      if (variant) updateVariant(variant);
    });
  });

  sizeSelects.forEach((select) => {
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (variant) updateVariant(variant);
    });
  });

  exclusiveAccordionGroups.forEach((group) => {
    const items = group.querySelectorAll('details');
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  });

  const defaultVariantId = container.dataset.hpDefaultVariantId;
  const defaultVariant = variants.find((item) => String(item.id) === String(defaultVariantId));
  if (defaultVariant) {
    updateVariant(defaultVariant);
  } else {
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    const variant = variants.find((item) => String(item.id) === String(urlVariantId));
    if (variant) updateVariant(variant);
  }
})();
